import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';


const Product: React.FC<any> = ({ image, title, content, category, id, sef_url }) => {

  return (
    <div className="product">
      <Link to={sef_url} className="product-link">
        <div className="product-thumb">
          <img src={image} alt={title} style={{ objectFit: 'cover', width: '236px', height: '282px' }} />
        </div>
        <h4>{title}</h4>
        <p>{category.title}</p>
      </Link>
    </div>
  );
};

export default Product;
